var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViberIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 90,
    viewBox: "0 0 88 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_52_63072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3242 10.8277C68.5424 9.22277 61.342 4.12005 45.3037 4.05073C45.3037 4.05073 26.3903 2.93733 17.1704 11.1933C12.038 16.2046 10.2325 23.5372 10.0421 32.6282C9.85165 41.7192 9.60525 58.7563 26.428 63.3758H26.4441L26.4334 70.4248C26.4334 70.4248 26.3258 73.2787 28.2507 73.8606C30.5791 74.5665 31.9455 72.3974 34.1685 70.0593C35.3886 68.7758 37.0736 66.8903 38.3432 65.4492C49.8485 66.3946 58.6973 64.2339 59.7022 63.9146C62.0253 63.1794 75.1703 61.5355 77.3083 44.4995C79.5151 26.9405 76.2409 15.8338 70.3242 10.8277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5827 14.3747C65.0763 13.0386 58.5743 9.05031 45.0074 8.99254C45.0074 8.99254 28.9422 7.96213 21.1436 14.8578C16.8031 19.0415 15.3409 25.2628 15.1806 32.8549C15.0202 40.447 14.1896 54.9506 28.4149 58.8086C28.4149 58.8086 28.359 69.576 28.3525 70.5223C28.3525 71.1841 28.4601 71.6368 28.8475 71.7303C29.1262 71.7964 29.5436 71.6557 29.8987 71.3101C32.1733 69.0802 39.4554 60.5039 39.4554 60.5039C49.2263 61.1268 57.0001 59.2434 57.8362 58.9766C59.8073 58.358 70.4691 57.4641 72.2735 43.2357C74.1381 28.5694 71.5881 18.5583 66.5827 14.3747Z",
    fill: "#7360F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5794 26.7134C45.6055 26.225 46.0322 25.8498 46.5324 25.8752C48.4041 25.9706 49.9613 26.5236 51.0704 27.6431C52.1752 28.7582 52.7168 30.3161 52.8118 32.187C52.8367 32.6755 52.4512 33.091 51.9508 33.1153C51.4505 33.1395 51.0248 32.7632 51 32.2748C50.9186 30.6732 50.4685 29.5829 49.7664 28.8742C49.0686 28.1699 48.0036 27.7235 46.4379 27.6438C45.9377 27.6183 45.5533 27.2017 45.5794 26.7134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2046 21.9429C44.2412 21.4552 44.6758 21.0888 45.1754 21.1245C48.9845 21.3966 52.0503 22.6671 54.2836 25.0469L54.2839 25.0472C56.4928 27.4036 57.5427 30.3348 57.4665 33.7731C57.4557 34.262 57.0409 34.6497 56.54 34.6391C56.0392 34.6286 55.642 34.2236 55.6528 33.7347C55.7201 30.7027 54.8067 28.228 52.9456 26.2428C51.0902 24.2658 48.4966 23.1374 45.043 22.8907C44.5434 22.855 44.168 22.4307 44.2046 21.9429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6026 17.4081C42.6061 16.9191 43.015 16.5254 43.5159 16.5288C48.7798 16.5646 53.2291 18.2753 56.8015 21.675C60.4037 25.103 62.1851 29.77 62.2303 35.5664C62.2341 36.0554 61.8311 36.4548 61.3302 36.4586C60.8293 36.4623 60.4201 36.0689 60.4163 35.5799C60.3739 30.1484 58.7187 25.9727 55.5352 22.9431C52.3218 19.885 48.332 18.3325 43.5033 18.2997C43.0023 18.2963 42.5991 17.8971 42.6026 17.4081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6649 44.0906C46.6649 44.0906 47.9399 44.1957 48.6264 43.3701L49.9649 41.7262C50.6104 40.9111 52.1684 40.3912 53.6942 41.221C54.8375 41.8575 55.9475 42.5496 57.02 43.2944C58.0325 44.0213 60.1058 45.7103 60.1123 45.7103C61.1 46.5243 61.3281 47.7197 60.6557 48.9801C60.6557 48.9875 60.6503 49.0001 60.6503 49.0064C59.9096 50.2598 58.9693 51.3901 57.8646 52.3549C57.8517 52.3613 57.8517 52.3676 57.8399 52.3739C56.8801 53.1567 55.9372 53.6017 55.0111 53.7089C54.8748 53.7322 54.7362 53.7406 54.598 53.7341C54.1896 53.7379 53.7833 53.6769 53.395 53.5534L53.3649 53.5104C51.9382 53.1175 49.556 52.1344 45.5889 49.9979C43.2932 48.7761 41.1077 47.3668 39.0556 45.7849C38.0271 44.9924 37.046 44.143 36.1172 43.2409L36.0182 43.1442L35.9192 43.0476L35.8202 42.951C35.7869 42.9194 35.7546 42.8869 35.7212 42.8543C34.7971 41.9476 33.927 40.9898 33.1152 39.9858C31.495 37.9828 30.0513 35.8496 28.7995 33.6089C26.611 29.7352 25.6039 27.4117 25.2015 26.0168L25.1574 25.9874C25.0312 25.6083 24.9691 25.2117 24.9734 24.8131C24.9659 24.6782 24.9742 24.5429 24.9981 24.4098C25.1136 23.5072 25.5702 22.586 26.3678 21.6462C26.3743 21.6347 26.3808 21.6347 26.3872 21.6221C27.3753 20.5437 28.5332 19.626 29.8174 18.9037C29.8238 18.9037 29.8368 18.8974 29.8443 18.8974C31.1355 18.2409 32.3599 18.4636 33.1927 19.4226C33.1992 19.4289 34.9261 21.453 35.6674 22.4414C36.4305 23.4894 37.1394 24.574 37.7914 25.6912C38.6414 27.1796 38.1088 28.7037 37.2738 29.3318L35.59 30.6385C34.7399 31.3086 34.8518 32.5533 34.8518 32.5533C34.8518 32.5533 37.3459 41.7682 46.6649 44.0906Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_52_63072",
    x: 0,
    y: 0.000488281,
    width: 87.9999,
    height: 89.9956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_52_63072"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_52_63072",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViberIc);
export default __webpack_public_path__ + "static/media/viber_ic.d52aaf8e.svg";
export { ForwardRef as ReactComponent };